<div *ngIf="isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>

<!-- HEADER / NAV (shared for PDF + HTML) -->
<!-- HEADER / NAV (shared for PDF + HTML) -->
<nav
	[hidden]="!isPrimary"
	id="mention_table"
	class="task-report-nav"
	aria-label="Task report navigation"
>
	<div class="task-report-nav-left">
		<button
			type="button"
			class="task-report-nav-button"
			(click)="onBackClicked()"
		>
			<span aria-hidden="true">&lt;</span>
			<span>Back</span>
		</button>

		<button
			*ngIf="currentTask.prevTask"
			type="button"
			class="task-report-nav-button"
			(click)="onPreviousClicked()"
		>
			<span aria-hidden="true">&lt;&lt;</span>

			<span *ngIf="viewerPanelInFocus">Previous</span>
		</button>
	</div>

	<div
		*ngIf="viewerPanelInFocus"
		class="task-report-nav-title"
		[title]="currentTask.name.trim()"
	>
		<span class="task-report-nav-title-label">Task name:</span>

		<span class="task-report-nav-title-value">
         {{ currentTask.name.trim() }}

			<span *ngIf="currentTask.type === WorkflowType.Form">
            &nbsp;-&nbsp;{{ currentTask.processId }}
         </span>
      </span>
	</div>

	<div class="task-report-nav-right">
		<div
			*ngIf="canShowViewerToggle"
			class="viewer-toggle"
			role="group"
			aria-label="Report viewer"
		>
			<button
				type="button"
				class="viewer-toggle-button"
				[class.viewer-toggle-button-active]="activeViewer === 'pdf'"
				[attr.aria-pressed]="activeViewer === 'pdf'"
				[disabled]="activeViewer === 'pdf'"
				(click)="setActiveViewer('pdf')"
			>
				PDF
			</button>

			<button
				type="button"
				class="viewer-toggle-button"
				[class.viewer-toggle-button-active]="activeViewer === 'html'"
				[attr.aria-pressed]="activeViewer === 'html'"
				[disabled]="activeViewer === 'html'"
				(click)="setActiveViewer('html')"
			>
				HTML
			</button>
		</div>

		<div class="task-report-due-date">
			<span class="task-report-due-label">Due:</span>

			<span class="task-report-due-value" data-cy="due-date">
            {{ currentTask.dueDate | DateLocalFormat: false }}
         </span>
		</div>

		<button
			*ngIf="currentTask.nextTask"
			type="button"
			class="task-report-nav-button task-report-nav-next"
			(click)="onNextClicked()"
		>
			<span *ngIf="viewerPanelInFocus">Next</span>
			<span aria-hidden="true">&gt;</span>
		</button>
	</div>
</nav>

<!-- REVIEW (non-form tasks) -->
<div *ngIf="canReviewNonFormTask && activeViewer !== 'html'" class="task-report-actions">
	<button
		data-cy="review-button"
		(click)="onReviewClicked()"
		[disabled]="isSubmitDisabled"
		class="p-button-raised w-fit task-report-primary-action"
		label="Review"
		pButton
		pRipple
		type="button"
	></button>
</div>

<!-- FORM ACTIONS (phobos forms) -->
<div *ngIf="canReviewFormTask" [class]="formActionsContainerClass" class="choose-button-padding">
	<div class="mb-2">
		<app-group-drop-down
			(groupChange)="onGroupChange($event)"
			label="Please Select a Group to Assign the Form to"
		></app-group-drop-down>
	</div>

	<div class="mb-2">
		<button
			(click)="onAssignClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised"
			label="Review & Assign"
			pButton
			pRipple
			type="button"
		></button>
	</div>

	<div class="mb-2">
		<button
			(click)="onCompleteClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised"
			label="Review & Complete Task"
			pButton
			pRipple
			type="button"
		></button>
	</div>
</div>

<!-- RESEND / REVERT (completed phobos forms) -->
<div *ngIf="canShowResendAndRevertRow" class="flex justify-content-end choose-button-padding">
	<div class="flex gap-3 w-full justify-content-end">
		<button
			(click)="onReopenClicked($event)"
			*ngIf="canShowRevertButton"
			[disabled]="isSubmitDisabled"
			class="p-button-raised p-mr-2 p-mb-2 max-w-fit"
			label="Revert Task"
			pButton
			pRipple
			type="button"
		></button>

		<button
			(click)="onResendClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised max-w-fit"
			label="Resend Completion Email"
			pButton
			pRipple
			type="button"
		></button>
	</div>
</div>

<!-- VIEWER SLOT: Parent renders either PDF viewer OR HTML viewer here -->
<ng-content></ng-content>
